import type { PaigeClient } from '@paige/api-client';
import type { AdminApi } from './data-source';
import type { PickerCompany } from '@paige/admin';
import type { AdminFlow, FlowItemsPage } from './types';
import { unwrap } from './http';

/** Stages and queues (`/admin/flow`): the live picture, and the items behind a count on it. */
export function flowApi(
  client: PaigeClient,
): Pick<AdminApi, 'getFlow' | 'listFlowItems' | 'searchCompanies'> {
  return {
    async searchCompanies(q) {
      const r = await client.GET('/admin/companies', { params: { query: q ? { q } : {} } });
      return (unwrap(r) as { companies: PickerCompany[] }).companies;
    },
    async getFlow(company) {
      const r = await client.GET('/admin/flow', {
        params: { query: company ? { company } : {} },
      });
      return unwrap(r) as AdminFlow;
    },
    async listFlowItems(q) {
      const query = {
        place: q.place,
        sort: q.sort,
        offset: q.offset,
        limit: q.limit,
        ...(q.class ? { class: q.class } : {}),
        ...(q.reason ? { reason: q.reason } : {}),
        ...(q.company ? { company: q.company } : {}),
      };
      const r = await client.GET('/admin/flow/items', { params: { query } });
      return unwrap(r) as FlowItemsPage;
    },
  };
}
